import React from 'react';


const AboutComponent = () => {
    return (
        <section className="backlight-bottom divider-top">
            <div className="stg-row stg-large-gap stg-valign-middle stg-tp-column-reverse">
                <div className="stg-col-6" data-appear="fade-right" data-unload="fade-left">
                    <h3>Capture Your Vision. Elevate Your Story.</h3>
                    <p className="infocolors-large-text">At INFOCOLORS, we believe in the power of visual storytelling. As a dynamic multi-platform media brand, we connect you to the creative and artistic heart of the world, transforming your ideas into stunning visual realities. </p>
                    <p>From capturing unforgettable moments to crafting compelling narratives, INFOCOLORS offers a comprehensive suite of media services designed to meet your every need. We blend creativity with technical expertise to deliver exceptional results.</p>
                    <div className="align-right">
                        <a href="/about" className="infocolors-arrow-link">Learn More About Us</a>+
                    </div>
                </div>
                <div className="stg-col-6 stg-tp-bottom-gap-l stg-m-bottom-gap" data-unload="fade-right" data-appear="fade-left">
                    <div className="infocolors-parallax-media">
                        <img className="infocolors-lazy" src={process.env.PUBLIC_URL + "/img/null.png"} data-src={process.env.PUBLIC_URL + "/img/home/about03.jpg"} alt="About Us" width="960" height="960" />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutComponent;
